import classNames from "classnames/bind";
import React from "react";
import CurrentPageInfo from "./CurrentPageInfo";
import PageControls from "./PageControls";
import PageSizeControls from "./PageSizeControls";
import styles from "./Pagination.module.scss";
import type { PaginationProps } from "./types";

const cx = classNames.bind(styles);

/**
 * Controls and information for navigating paginated data
 */
const Pagination = ({
  page,
  pageSize,
  pageTotal = 0,
  total,
  hasNextPage,
  availablePages,
  pageSizeText = "Items per page",
  sortDirection = "asc",
  onChange,
  isLoading,
  isBusy,
  showPageSizeControls = true,
  pageSizeOptions,
  showCurrentPageControls = true,
  showPageControls = true,
  className,
  style,
}: PaginationProps) => {
  return (
    <div
      className={cx("flex", className)}
      style={style}
    >
      {showPageSizeControls || showCurrentPageControls ? (
        <div className={cx("flex")}>
          {showPageSizeControls ? (
            <>
              <PageSizeControls
                pageSize={pageSize}
                total={total}
                hasNextPage={hasNextPage}
                pageSizeText={pageSizeText}
                onChange={onChange}
                isLoading={isLoading}
                isBusy={isBusy}
                pageSizeOptions={pageSizeOptions}
              />
              <div
                className={cx("divider")}
                role="presentation"
              />
            </>
          ) : null}
          {showCurrentPageControls ? (
            <CurrentPageInfo
              page={page}
              pageSize={pageSize}
              pageTotal={pageTotal}
              total={total}
              sortDirection={sortDirection}
              isLoading={isLoading}
              isBusy={isBusy}
            />
          ) : null}
        </div>
      ) : null}
      {showPageControls ? (
        <PageControls
          page={page}
          pageSize={pageSize}
          total={total}
          hasNextPage={hasNextPage}
          availablePages={availablePages}
          onChange={onChange}
          isLoading={isLoading}
          isBusy={isBusy}
        />
      ) : null}
    </div>
  );
};

export default Pagination;
